import { GenericError, LoadingSpinner } from '@psyomics/ui-components';
import { Navigate, useParams } from 'react-router-dom';

import { useReferralRequestService } from '../../../features/referral-request/hooks/use-referral-request-service';
import { ReferralRequestCreate as ReferralRequestCreateFeature } from '../../../features/referral-request/referral-request-create';

const ReferralRequestCreate = () => {
  const { orgCode, serviceCode } = useParams<{ orgCode: string; serviceCode: string }>();
  const { service, fetching } = useReferralRequestService(orgCode ?? '', serviceCode ?? '');

  if (!orgCode || !serviceCode) return <Navigate to="/" />;
  if (fetching) return <LoadingSpinner />;
  if (!service) return <GenericError titleKey="common.errors.notFound" />;

  return <ReferralRequestCreateFeature orgCode={orgCode} service={service} serviceCode={serviceCode} />;
};

export { ReferralRequestCreate };
